export default "__VITE_ASSET__R74BFkQT__"